import { render, staticRenderFns } from "./SaveNeedMoreDialog.vue?vue&type=template&id=8a6cf386&scoped=true"
import script from "./SaveNeedMoreDialog.vue?vue&type=script&lang=js"
export * from "./SaveNeedMoreDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6cf386",
  null
  
)

export default component.exports